.legend {
  padding-left: 3em;
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 2em;

  @media print {
    max-width: 30%;
  }
}

.legendItem {
  flex-grow: 1;
  display: flex;
  align-items: center;
  margin-right: 1em;
}

.legendValue {
  font-size: 1.5em;
  font-weight: bold;
}

.legendDescription {
  flex: 1 1 100%;
  margin-left: 1em;
  font-size: 0.6em;
  text-transform: uppercase;
  height: 2em;
  line-height: 2;
  padding-left: 0.5em;

  p {
    margin-bottom: 0;
    font-size: 1em;
  }
}

.top {
  align-self: baseline;
}

.minMax {
  position: relative;
  top: -5px;
}

.text {
  margin-bottom: 1em;
}
